import Vue from 'vue';
import Router from 'vue-router';
//import LeituradeMapaQuiz from '../components/LeituradeMapaQuiz.vue';
//import LeituradeMapaVSL from '../components/LeituradeMapaVSL.vue';
import HelloWorld from '../components/HelloWorld.vue'
import PaginaPrincipal from '../components/PaginaPrincipal.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/enviodosdados',
      name: 'HelloWorld',
      component: HelloWorld,
      props: true
    },
    {
      path: '/pGwZSDj',
      name: 'PaginaPrincipal',
      component: PaginaPrincipal,
      props: true
    },
],
});
